// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/textfield/Size.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextField, view } from '@sail/ui';
export const Size = () => <view.div css={{
  layout: 'column',
  gap: 'medium'
}}>
    <TextField label="Small" size="small" />
    <TextField label="Medium" size="medium" />
    <TextField label="Large" size="large" />
  </view.div>;